import React__default from 'react';
import styles from './styles.module.scss.js';
import propsToClass from '../../../helpers/propsToClass.js';
import getRelFromTarget from '../../../helpers/getRelFromTarget.js';
import { COLORS } from '../../../helpers/constants.js';

/**
 * @description Nimvelo Button component
 * @props borderless, buttonProps, children, className, color, disabled, fullWidth, href, inverted, kind,
 *  leftIcon, linkProps, mini, onClick, rightIcon, rounded, seleced, size, target
 */
const NvButton = ({ borderless = false, buttonProps, children, className, color, disabled = false, fullWidth = false, href, inverted = false, kind = 'primary', leftIcon, linkProps, mini = false, onClick, rightIcon, rounded = false, selected = false, size = 'standard', target, }) => {
    const buttonColorStyle = {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        '--NvButtonBaseColor': color?.base || COLORS[kind.toUpperCase()],
        '--NvButtonTextColor': color?.text,
    };
    const invertedStyle = inverted ? 'is_inverted' : 'not_inverted';
    const staticClasses = `${styles[size]} ${styles.btn} ${styles[kind]} ${styles[invertedStyle]} ${className}`;
    const dynamicClasses = propsToClass(staticClasses, [
        [styles.disabled, disabled],
        [styles.rounded, rounded],
        [styles.mini, mini],
        [styles.selected, selected],
        [styles.full_width, fullWidth],
        [styles.borderless, borderless],
    ]);
    const content = (React__default.createElement(React__default.Fragment, null,
        leftIcon && React__default.createElement("div", { className: styles.icon }, leftIcon),
        children && React__default.createElement("span", { className: styles.children }, children),
        rightIcon && React__default.createElement("div", { className: styles.icon }, rightIcon)));
    const link = (React__default.createElement("a", { className: dynamicClasses, href: !disabled ? href : undefined, target: target, rel: getRelFromTarget(target), ...linkProps, onClick: onClick, style: buttonColorStyle }, content));
    const button = (React__default.createElement("button", { className: dynamicClasses, onClick: onClick, ...buttonProps, type: "button", style: buttonColorStyle, disabled: disabled }, content));
    if (href) {
        return link;
    }
    return button;
};

export { NvButton, NvButton as default };
//# sourceMappingURL=component.js.map
